import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

const ReclassificationTableHeader: FC = () => {
  const { t } = useTranslate();

  return (
    <>
      <thead className="tb-head">
        <tr>
          <th className="text-center">{t('From')}</th>
          <th className="text-center">{t('To')}</th>
          <th className="text-left">{t('Class')}</th>
          <th className="text-center">{t('NewFrom')}</th>
          <th className="text-center">{t('NewTo')}</th>
          <th className="text-left">{t('NewClass')}</th>
        </tr>
      </thead>
    </>
  );
};

export default ReclassificationTableHeader;
